import React, { forwardRef, useCallback } from 'react';
import styled from '@emotion/styled';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
const ParallaxVideo = forwardRef(({ progress, ...props }, ref) => {
    const callbackRef = useCallback((node) => {
        if (node && (node === null || node === void 0 ? void 0 : node.tagName) === 'VIDEO') {
            node.load(); // iOS safari bug fix https://stackoverflow.com/a/62035927
            let seeking = false;
            let updatedDuringSeek = false;
            const updateTime = (value) => {
                // Round to nearest 60fps float
                node.currentTime =
                    Math.ceil((node.duration && value ? node.duration * value : 0) * 60) / 60;
            };
            const unsubscribe = progress.on('change', (value) => {
                if (node.duration && !seeking) {
                    updateTime(value);
                }
                else if (seeking) {
                    updatedDuringSeek = true;
                }
            });
            const handleSeeked = () => {
                seeking = false;
                if (updatedDuringSeek) {
                    updatedDuringSeek = false;
                    updateTime(progress.get());
                }
            };
            const handleSeeking = () => {
                seeking = true;
            };
            node.addEventListener('seeking', handleSeeking);
            node.addEventListener('seeked', handleSeeked);
            return () => {
                unsubscribe();
                node.removeEventListener('seeking', handleSeeking);
                node.removeEventListener('seeked', handleSeeked);
            };
        }
    }, [progress]);
    const combinedRef = useCombinedRef(ref, callbackRef);
    return (React.createElement(Container, { ref: combinedRef, preload: "auto", tabIndex: -1, controls: false, muted: true, ...props }));
});
ParallaxVideo.displayName = 'ParallaxVideo';
export default ParallaxVideo;
const Container = styled.video `
  pointer-events: none;
`;
